<template>
  <div
    ref="chart"
    id="base-chart"
    :style="{ height: height, width: width }"
  ></div>
</template>

<script>
// import * as echarts from "echarts";
// 按需引入 引入 ECharts 主模块
var echarts = require("echarts/lib/echarts");
// 引入柱状图
require("echarts/lib/chart/pie");
// 引入提示框和标题组件
require("echarts/lib/component/tooltip");
require("echarts/lib/component/title");
require("echarts/lib/component/legend");
require("echarts/lib/component/toolbox");
import chartResize from "./mixins/chart-resize";

export default {
  mixins: [chartResize],
  name: "NightingaleChart",
  props: {
    width: {
      type: String,
      default: "100%",
    },
    height: {
      type: String,
      default: "85%",
    },
    // 父组件传递过来的图表数据
    chartData: Array,
  },
  data() {
    return {
      chart: null, //chart实例
      data: this.chartData,
      name: "个人考评得分",
      // option: {
      //   tooltip: {
      //     trigger: "item",
      //   },
      //   legend: {
      //     top: "bottom",
      //   },
      //   toolbox: {
      //     show: false,
      //     feature: {
      //       mark: { show: true },
      //       dataView: { show: true, readOnly: true },
      //       restore: { show: true },
      //       saveAsImage: { show: true },
      //     },
      //   },
      //   series: [
      //     {
      //       name: "Nightingale Chart",
      //       type: "pie",
      //       radius: [50, 250],
      //       center: ["50%", "50%"],
      //       roseType: "area",
      //       itemStyle: {
      //         borderRadius: 8,
      //       },
      //       label: {
      //         show: false,
      //         position: "center",
      //       },
      //       labelLine: {
      //         show: false,
      //       },
      //       data: [
      //         { value: 40, name: "共性指标" },
      //         { value: 38, name: "个性指标" },
      //         { value: 32, name: "关键指标" },
      //       ],
      //     },
      //   ],
      // },
    };
  },
  methods: {
    initEchart() {
      this.chart = echarts.init(document.getElementById("base-chart"));
      this.chart.showLoading();
      this.setOptions(this.option);
      this.chart.hideLoading();
    },
    setOptions(options) {
      this.chart.setOption({
        tooltip: {
          trigger: "item",
        },
        legend: {
          orient: "vertical",
          left: "left",
        },
        toolbox: {
          show: false,
          feature: {
            mark: { show: true },
            dataView: { show: true, readOnly: true },
            restore: { show: true },
            saveAsImage: { show: true },
          },
        },
        series: [
          {
            name: this.name,
            type: "pie",
            // radius: [50, 250],
            radius: "75%",
            center: ["50%", "40%"],
            // roseType: "area",
            itemStyle: {
              borderRadius: 8,
            },
            label: {
              show: false,
              position: "center",
            },
            labelLine: {
              show: false,
            },
            data: this.data,
          },
        ],
      });
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.initEchart();
    });

    // 不导入resize包直接监听也行
    // window.addEventListener(
    //   "resize",
    //   () => {
    //     this.chart.resize();
    //   },
    //   false
    // );
  },
  beforeUnmount() {
    if (!this.chart) {
      return;
    }
    /* 释放图表实例 */
    this.chart.dispose();
    /* dispose 会释放内部占用的一些资源和事件绑定，但是解除实例的引用我们是做不到的，所以需要重新赋值为null */
    this.chart = null;
  },
  watch: {
    /* 如果图表数据是后台获取的，监听父组件中的数据变化，重新触发Echarts */
    chartData: {
      // deep: true,
      handler(val) {
        console.log(val);
        this.data = val;
        this.setOptions(val);
      },
    },
  },
};
</script>

<style scoped lang="scss">
</style>